import React from 'react'

import { Button, Modal } from '_zari/core'

import { NuevoActualizarProductoForm } from 'sharedComponents/forms'

const NuevoActualizarProductoModal = ({ handleClose, show }) => {
  return (
    <Modal show={show} onHide={handleClose} fullSize>
      <Modal.Header>
        <Modal.Title>MANTENIMIENTO PRODUCTO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NuevoActualizarProductoForm editarData={{}} handleClose={handleClose} flagModal />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(NuevoActualizarProductoModal)
